export class OnlineAppointment {

  onlineAppointmentID: number;
  onlinePatientID: number;
  patientID: number;

  appointmentDate: Date;
  appointmentTime: string;
  complaint: string;
  appointmentRemarks: string;
  appointmentStatus: number;
  assignee: number;
  specializationID: number;
  stateID: number;
  cityID: number;
  createdAt: Date;
  createdBy: number;
  modifiedAt: Date;
  modifiedBy: number;

  confirmeddAt: Date;
  confirmedBy: number;

  fromDate: string;
  toDate: string;
  email: string;
  mobileNo: string;

  visitID: number;
  specializationNameEn: string;
  patientNameEn: string;
}
